import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    badge: 'flex w-fit items-center gap-1.5 rounded-[40px] px-[10px] py-[2px]',
    icon: 'text-blue-dark size-3 shrink-0',
    text: 'heading-xs-bold'
  },
  variants: {
    mode: {
      form: {
        base: 'mb-6 flex flex-col flex-wrap gap-[6px]'
      },
      list: {
        base: 'mb-0'
      }
    },
    variant: {
      default: {
        badge: 'bg-bg-items-white'
      },
      accent: {
        badge: 'bg-icon-star'
      }
    }
  },
  defaultVariants: {
    mode: 'form'
  }
});
